<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <h3 class="headline mb-0">
          Dates
        </h3>

        <div>
          Surfaces our date utilities.
        </div>
      </div>
    </v-card-title>

    <v-card-text>
      <v-col
        class="pa-0"
      >
        <v-menu
          :ref="name"
          v-model="menu"
          :return-value="value"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="formattedInput"
              :label="label"
              readonly
              v-on="on"
            />
          </template>

          <v-date-picker
            v-model="value"
            no-title
            scrollable
          >
            <!-- eslint-disable-next-line vue/html-self-closing -->
            <v-spacer></v-spacer>

            <v-btn
              text
              color="redorange"
              @click="resetDate"
            >
              Reset
            </v-btn>

            <v-btn
              text
              color="coolgray"
              @click="closeMenu"
            >
              Cancel
            </v-btn>

            <v-btn
              text
              color="primary"
              @click="$refs[name].save(value)"
            >
              Apply
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-card-text>

    <v-card-actions>
      <v-btn
        flat
        color="primary"
      >
        Convert Date
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import dates from 'src/utils/dates'

export default {
  name: 'DevDates',
  data() {
    return {
      menu: false,
      name: 'inputDate',
      value: null,
      label: 'Date',
    }
  },
  computed: {
    formattedInput() {
      const { value } = this

      if (!value) return ''

      return dates.getFormattedDate(value, 'dddd, MMMM DD, YYYY')
    },
    result() {
      const { value } = this

      if (!value) return ''

      return dates.getFormattedDate(value, 'MMM DD YYYY')
    },
  },
  methods: {
    closeMenu() {
      this.menu = false
    },
    resetDate() {
      this.value = null
    },
  },
}
</script>
